import licensesModalStyle from '../css/licenses-modal.module.css';

// Components
import Button from 'components/Button';
import LinkerWithA from 'components/LinkerWithA';
import ModalContainer from 'components/ModalContainer';
import RadioButton from 'components/RadioButton';
import Input from 'components/Input';
import Icon from 'components/Icon';
import ButtonWithIcon from 'components/ButtonWithIcon';
import InputWithUploadButton from 'components/InputWithUploadButton';

import { useState, useCallback, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import AuthOrganizationService from "services/Auth.Organization.service";

import { size, isNil, cloneDeep } from "lodash";

const AddLicenseModal = ({
  modalStatus,
  cancelModal,
  submitModal,
  info
}) => {
  const { t } = useTranslation();
  const [addLicenseMode, setAddLicenseMode] = useState('add');
  const [firstLicense, setFirstLicense] = useState('');
  const [licenseList, setLicenseList] = useState([]);
  const [file, setFile] = useState(null);

  useEffect(() => {
    setAddLicenseMode('add');
    setFirstLicense('');
    setLicenseList([]);
    setFile(null);
  }, [modalStatus.addLicense.status]);

  const insertKey = (targetValue, targetIndex) => {
    const copy = cloneDeep(licenseList);
    for (let [index, value] of copy.entries()) {
      if (index === targetIndex) {
        copy[index] = targetValue;
        break;
      }
    }
    setLicenseList(copy);
  };

  const addNew = () => {
    const copy = cloneDeep(licenseList);
    copy.push('');
    setLicenseList(copy);
  };

  const deleteNew = (index) => {
    const copy = cloneDeep(licenseList);
    copy.splice(index, 1);
    setLicenseList(copy);
  };

  const listCheck = () => {
    for (const [index, value] of licenseList.entries()) {
      if (size(value) === 0) {
        return false;
      }
    }
    return true;
  };

  const checkSubmit = () => {
    if (addLicenseMode === 'add') {
      if (size(firstLicense) === 0 || !listCheck()) {
        return true;
      }
      return false;
    } else {
      if (isNil(file)) {
        return true;
      }
      return false;
    }
  };

  const fileSelect = (target) => {
    setFile(target);
  };

  const submit = async () => {

    try {
      let res;
      if (addLicenseMode === 'add') {
        const licenseKeys = [firstLicense];
        const data = {
          licenseKeys: licenseKeys.concat(licenseList)
        };
        res = await AuthOrganizationService.bindLicense(info.orgId, data);
      } else {
        res = await AuthOrganizationService.bindBulkLicense(info.orgId, file);
      }

      if (res?.data) {
        submitModal(res?.data);
      } else {
        submitModal([{ error: res.error, licenseKey: '' }]);
      }
      cancelModal();
    } catch (error) {
      console.debug('AddLicenseModal submit:', error);
    }
  };

  return (
    <div className={licensesModalStyle['add-licenses-modal']}>
      <ModalContainer
        modalWidthType="modal-500px"
        openModal={modalStatus.addLicense.status}
        closeModal={() => cancelModal()}
      >
        <div className="header">
          <div className="title">{t('b3e05ad310')}</div>
        </div>
        <div className="body">

          <div>
            <div className="modal-form-title">
              <RadioButton
                id="AddLicenseKeys"
                name="AddLicenseKeys"
                label={t('b3e05ad310')}
                checked={addLicenseMode === 'add'}
                labelClassName="form-title"
                onChange={() => setAddLicenseMode('add')}
              />
            </div>
          </div>
          <div
            className={`mb-1 ms-3 ${addLicenseMode === 'add' ? 'd-block' : 'd-none'
              }`}
          >
            <Row>
              <Col sm={6}>
                <div className="modal-form-title required">{t('5d5c4ad5db')} #1</div>
                <div className={licensesModalStyle['add-licenses-input-group']}>
                  <Input
                    type="text"
                    value={firstLicense}
                    minLength={0}
                    maxLength={12}
                    onChange={e => { setFirstLicense(e.target.value); }}
                    onFocus={() => { }}
                    onBlur={() => { }}
                    isInvalid={firstLicense.length === 0}
                  />
                </div>
              </Col>
              {licenseList.map((item, index) => {
                return (
                  <Col key={`licenseList_${index}`} sm={6}>
                    <div className="modal-form-title required">{`${t('5d5c4ad5db')} #${index + 2}`}</div>
                    <div className={licensesModalStyle['add-licenses-input-group']}>
                      <Input
                        type="text"
                        value={item}
                        minLength={0}
                        maxLength={12}
                        onChange={e => { insertKey(e.target.value, index); }}
                        onFocus={() => { }}
                        onBlur={() => { }}
                        isInvalid={item.length === 0}
                      />
                      <Icon
                        iconTitle="delete"
                        className={`icon-close ${licensesModalStyle['icon']}`}
                        onClick={() => { deleteNew(index); }}
                      />
                    </div>
                  </Col>
                );

              })
              }
            </Row>
            {(size(firstLicense) > 0 && listCheck()) &&
              <ButtonWithIcon
                label={t('ec211f7c20')}
                className="d-flex justify-content-center mt-4"
                iconClassName="icon-expand"
                onClick={() => { addNew(); }}
              ></ButtonWithIcon>
            }
          </div>

          {/* Bulk import */}
          <div className="mt-3">
            <div className="modal-form-title">
              <RadioButton
                id="bulkImport"
                name="bulkImport"
                label={t('318c3955e6')}
                checked={addLicenseMode === 'bulk'}
                labelClassName="form-title"
                onChange={() => {
                  setAddLicenseMode('bulk');
                }}
              />
            </div>
          </div>

          {/* Bulk import content */}
          <div
            className={`mb-1 ms-3 ${addLicenseMode === 'bulk' ? 'd-block' : 'd-none'
              }`}
          >
            <div className={`mb-1 ${licensesModalStyle['bulk-import-hint']}`}>
              {t('3d67bdd11a')}
            </div>
            <InputWithUploadButton
              buttonLabel='1b9abf135c'
              containerClassName="my-2"
              accept='text/csv'
              value={file?.name || ''}
              onClick={e => { fileSelect(null); }}
              onChange={e => { fileSelect(e.target.files[0]); }}
            />
            <div className="fst-italic">
              <span>{t('602ec1add4')}</span>
              <LinkerWithA
                label={t('bc98d84673')}
                href="/file/Sample-Registered-Licenses.csv"
                className="linker-blue text-decoration-none mx-1 fw-light"
              />
            </div>
          </div>
        </div>
        <div className={`footer ${licensesModalStyle['footer']}`}>
          <Button
            label={t('ea4788705e')}
            className="btn-cancel"
            onClick={() => cancelModal()}
          />
          <Button
            label={t('ec211f7c20')}
            className="btn-submit"
            onClick={() => { submit(); }}
            disabled={checkSubmit()}
          />
        </div>
      </ModalContainer>
    </div>
  );
};

export default AddLicenseModal;